// extracted by mini-css-extract-plugin
module.exports = {"overlapping":"ActorLabelPositioner_overlapping__MPc_k","notOverlapping":"ActorLabelPositioner_notOverlapping__1jMc5"};